import { ImpactCategoryId } from '@upright/common/model/input/impacts/impact-categories';
import { getDimensionOfImpactCategory } from '../../../../../../../common/model/input/impacts/types';
import { CUSTOM_VALUE_SET_NAME } from '../../../../../../../common/model/input/value-sets/value-sets';
import { ORDERED_DIMENSIONS, ORDERED_IMPACTS_BY_DIMENSION, Valence } from '../../../../../../../common/model/types';
import { keysOf } from '../../../../../../../common/utils';
import { getNormalizedValue, getPossibleUniqueValueOfValence, getValueSetMinMax } from './shared';
import { StateHooksOfValueSetSelector, ValueSetWithName } from './types';

export function updateSelectionToMatchValueSet(stateHooks: StateHooksOfValueSetSelector, valueSet: ValueSetWithName) {
  if (valueSet.name === CUSTOM_VALUE_SET_NAME) {
    return;
  }
  const { min, max } = getValueSetMinMax(valueSet.valueSet);

  function setNormalizedValue(impactCategory: ImpactCategoryId, valence: Valence, value: number, valueSetName: string) {
    const dimension = getDimensionOfImpactCategory(impactCategory);
    const hooksOfValence = stateHooks[dimension][valence];

    const [valueOfRadioButton, setValueOfRadioButton] = hooksOfValence.stateHooksOfImpactCategories[impactCategory];
    const normalizedValue = getNormalizedValue(value, min, max, valueSetName);
    if (normalizedValue !== valueOfRadioButton) {
      setValueOfRadioButton(normalizedValue, false);
    }
  }

  // Convert value set values to the radio button step values.
  forEachValueSetValue(valueSet, setNormalizedValue);

  // Update the ValenceBlock open states and valence scores based on the value set.
  ORDERED_DIMENSIONS.forEach(dimension => {
    const impactCategories = ORDERED_IMPACTS_BY_DIMENSION[dimension];
    [Valence.POSITIVE, Valence.NEGATIVE].forEach(valence => {
      const uniqueValue = getPossibleUniqueValueOfValence(impactCategories, valence, valueSet.valueSet);
      const hooksOfValence = stateHooks[dimension][valence];
      const [, setValue] = hooksOfValence.valueStateHookOfValence;
      const [, setOpen] = hooksOfValence.openStateHookOfValence;
      if (uniqueValue !== undefined) {
        setValue(uniqueValue, false);
        setOpen(false);
      }
      if (uniqueValue === undefined) {
        setValue(undefined, false);
        setOpen(true);
      }
    });
  });
}

function forEachValueSetValue(
  valueSet: ValueSetWithName,
  iteratee: (impactCategory: ImpactCategoryId, valence: Valence, value: number, valueSetName: string) => void,
) {
  keysOf(valueSet.valueSet).forEach(impactCategory => {
    const valuesOfImpactCategory = valueSet.valueSet[impactCategory];
    keysOf(valuesOfImpactCategory).forEach(valence => {
      const value = valuesOfImpactCategory[valence];
      iteratee(impactCategory, valence as Valence, value, valueSet.name);
    });
  });
}
